import { useEffect, useState } from 'react';
import { ITechList, IUserBase } from '../../types/type';
import AdminTOList from '../AdminTOList/AdminTOList';
import { TechnicalService } from '../../services/technical.service';

function TechTOLists({ data }: { data: IUserBase }) {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTechLists = async () => {
    if (!data || !data.id) return;

    setLoading(true);
    setError(null);

    try {
      // Не нужно получать данные, так как теперь новый компонент AdminTOList
      // сам загружает данные через сервис с пагинацией и фильтрацией
    } catch (err: any) {
      console.error('Ошибка при загрузке технических осмотров:', err);
      setError(err.message || 'Не удалось загрузить данные технических осмотров');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTechLists();
  }, [data]);

  return (
    <div className="info__card __admin">
      {loading ? (
        <div className="loading-indicator">Загрузка...</div>
      ) : error ? (
        <div className="error-message">{error}</div>
      ) : (
        <AdminTOList user={data} />
      )}
    </div>
  );
}

export default TechTOLists;
